import { get } from "@/request/http";

// 从session获取用户信息
export const getSessionRequest = () => get("/login/getSessionRequest");
